<span>{{ getText() }}</span>
<app-mazars-information-icon *ngIf="code || reference" [message]="getTooltip()" uid="validation-result-tooltip"></app-mazars-information-icon>
